import { type ChangeEvent, memo } from 'react';
import { useDebouncedCallback } from 'use-debounce';

import { Search } from '@air/next-icons';
import { Input } from '@air/primitive-input';

export type LocationsFilterHeaderProps = {
  onSearchChange: (search: string) => void;
};

export const LocationsFilterHeader = memo(({ onSearchChange }: LocationsFilterHeaderProps) => {
  const [onChange] = useDebouncedCallback((event: ChangeEvent<HTMLInputElement>) => {
    onSearchChange(event.target.value);
  }, 300);

  return (
    <div data-testid="LOCATIONS_FILTER_HEADER">
      <div className="relative flex w-full items-center justify-between border-b border-b-grey-4 p-2">
        <Search className="absolute top-1/2 left-3 size-4 -translate-y-1/2 text-grey-10" />
        <Input
          className="w-full pl-8"
          data-testid="LOCATIONS_FILTER_HEADER_SEARCH"
          placeholder="Search libraries & boards"
          onChange={onChange}
        />
      </div>
    </div>
  );
});

LocationsFilterHeader.displayName = 'LocationsFilterHeader';
